<template>
  <a-layout class="index animated fadeIn">
    <a-card class="mb10">
      <a-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
      <SmallSquare content="客户信息" />
        <a-form-item ref="company" label="公司名称" name="company">
          <a-input
            v-model:value="form.company"
            placeholder="请输入公司名称"
            :readonly="$route.query.type == 'look'"
          />
        </a-form-item>
        <a-form-item ref="director_name" label="负责人" name="director_name">
          <a-input
            v-model:value="form.director_name"
            placeholder="请输入负责人"
            :readonly="$route.query.type == 'look'"
          />
        </a-form-item>
        <a-form-item
          ref="director_phone"
          label="负责人电话"
          name="director_phone"
        >
          <a-input
            v-model:value="form.director_phone"
            placeholder="请输入负责人电话"
            :readonly="$route.query.type == 'look'"
          />
        </a-form-item>
        <a-form-item ref="brand_name" label="品牌名称" name="brand_name">
          <a-input
            v-model:value="form.brand_name"
            placeholder="请输入品牌名称"
            :readonly="$route.query.type == 'look'"
          />
        </a-form-item>
        <a-form-item ref="account" label="账号" name="account">
          <a-input
            v-model:value="form.account"
            placeholder="请输入账号"
            :readonly="$route.query.type == 'look'"
          />
        </a-form-item>
        <a-form-item ref="password" label="密码" name="password">
          <a-input
            v-model:value="form.password"
            placeholder="请输入密码"
            type="password"
            :readonly="$route.query.type == 'look'"
          />
        </a-form-item>
        <a-form-item
          ref="business_license_img"
          label="营业执照"
          name="business_license_img"
        >
          <a-upload
            v-model:fileList="licenseImages"
            name="file"
            accept="image/jpeg,image/png,image/jpg"
            list-type="picture-card"
            class="avatar-uploader"
            :action="baseUrl + 'upload/alone'"
            :headers="header"
            @change="(e) => ImagesChange(e, 'business_license_img')"
            @preview="handlePreview"
            :beforeUpload="beforeUpload"
            :disabled="$route.query.type == 'look'"
          >
            <div v-if="licenseImages.length < 1">
              <plus-outlined />
              <div class="ant-upload-text">上传营业执照</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="商品注册证">
          <a-upload
            v-model:fileList="regCertImg"
            name="file"
            accept="image/jpeg,image/png,image/jpg"
            list-type="picture-card"
            class="avatar-uploader"
            :action="baseUrl + 'upload/alone'"
            :headers="header"
            @change="(e) => ImagesChange(e, 'product_reg_cert_img')"
            @preview="handlePreview"
            :beforeUpload="beforeUpload"
            :disabled="$route.query.type == 'look'"
          >
            <div v-if="regCertImg.length < 1">
              <plus-outlined />
              <div class="ant-upload-text">上传商品注册证</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="公司地址">
          <a-cascader
            :disabled="$route.query.type == 'look'"
            v-model:value="region"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            :options="cityList"
            placeholder="请选择地址"
            @change="onChangeAddress"
          />
        </a-form-item>
        <a-form-item label="详细地址">
          <a-input
            v-model:value="form.company_address"
            placeholder="请输入详细地址"
          />
        </a-form-item>
        <a-form-item ref="industry" label="所属行业" name="industry">
          <a-select
            v-model:value="form.industry"
            placeholder="请选择所属行业"
            :disabled="$route.query.type == 'look'"
          >
            <a-select-option
              v-for="item in industrysList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

   
       <SmallSquare content="开通产品" />
       <a-form-item
          ref="is_production_line"
          label="产线"
          name="is_production_line"
        >
          <a-radio-group v-model:value="form.is_production_line">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-item>
       <a-form-item ref="app_marks" label="SaaS应用" name="app_marks">
        <a-checkbox-group
            v-model:value="form.app_marks"
            :options="serveFeesList"
          />
        </a-form-item>
        <a-form-item
          :wrapper-col="{ span: 14, offset: 3 }"
          v-if="$route.query.type !== 'look'"
        >
          <a-button type="primary" @click="onSubmit()">
            确定开户
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>

<script>
import { toRefs, reactive, form, ref, onMounted, inject } from "vue"
import { getArea } from "@/api/public"
import { message } from "ant-design-vue"
import { $iscode } from "@/utils/app"
import { brandGetAppCost } from "@/api/product";
import {
  getBrandIndustrys,
  auditCustomerInfo,
  auditCustomer,
} from "@/api/brand"
import config from "@/config"
export default {
  setup() {
    const oss = config.oss[process.env.VUE_APP_type]
    const $route = inject("$route")
    const $router = inject("$router")
    const form = ref({})
    const ruleForm = ref(null)
    const state = reactive({
      labelCol: { span: 3 },
      wrapperCol: { span: 12 },
      cityList: [],
      region: [],
      industrysList: [],
      licenseImages: [],
      regCertImg: [],
      serveFeesList:[],
      rules: {
        company: [{ required: true, message: "请输入客户名称" }],
        director_name: [{ required: true, message: "请输入负责人" }],
        director_phone: [{ required: true, message: "请输入负责人电话" }],
        password: [{ required: true, message: "请输入密码" }],
        account: [{ required: true, message: "请输入账号" }],
        brand_name: [{ required: true, message: "请输入品牌名称" }],
      },
    })
    // state.region = [res.data.province, res.data.city, res.data.region];
    //获取省市区
    const getAreaList = async () => {
      let result = await getArea()
        .then((res) => res)
        .catch((error) => error)
      state.cityList = result.data
    }
    //选择省市区
    const onChangeAddress = (e) => {
      form.value.province = e[0]
      form.value.city = e[1]
      form.value.region = e[2]
    }
    const getIndustrys = async () => {
      let res = await getBrandIndustrys()
        .then((res) => res.data)
        .catch((error) => error)
      if ($iscode(res)) {
        state.industrysList = res.data
      } else {
        message.error(res.msg)
      }
    }
    const getDetail = async () => {
      let res = await auditCustomerInfo({ id: $route.query.id })
        .then((res) => res.data)
        .catch((error) => error)
      console.log(res)
      if ($iscode(res)) {
        form.value = res.data
        state.region = [res.data.province, res.data.city, res.data.region]
        form.value.app_marks=form.value.activate_app_marks.map(v=>String(v))
        state.licenseImages = [{url:oss + res.data.business_license_img}]
        state.regCertImg = [{url:oss + res.data.product_reg_cert_img}]
      } else {
        message.error(res.msg)
      }
    }
        //获取服务模块
        const getappServe = async () => {
      let result = await brandGetAppCost({ nopages: 1 })
        .then((res) => res.data)
        .catch((error) => error);
        console.log(result)
      state.serveFeesList=result.data.app_type_module.app_list.map(v=>{
        v['label']=v['name']
        v['value']=v['mark_id']
        return v
      })
    };
    onMounted(() => {
      getIndustrys()
      getAreaList()
      getDetail()
      getappServe()
    })
    // 上传 前
    const beforeUpload = (file, fileList) => {
      if (fileList.length > 1) {
        message.error("最多上传1张图")
        return false
      }
    }
    // 上传 图片
    const ImagesChange = (info, type) => {
      if (info.file.status === "done") {
        if (type == "business_license_img") {
          state.licenseImages = info.fileList
          form.value[type].push(info.file.response.data.path)
        } else {
          state[type] = info.fileList
          form.value[type] = info.file.response.data.path
        }
      }
      if (info.file.status === "error") {
        message.error("图片上传失败！")
      }
      if (info.file.status === "removed") {
        form.value[type] = ""
      }
    }
    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    }
    const handlePreview = async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      state.previewImage = file.url || file.preview
      state.previewVisible = true
    }
    //提交
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
            let res = await auditCustomer({
              ...form.value,
              customer_id:form.value.id
            })
              .then((res) => res.data)
              .catch((error) => error);
          if ($iscode(res, true)) {
            setTimeout(() => {
              state.confirmShow = false;
              $router.go(-1);
            }, 1000);
          }
          
        })
        .catch((error) => {
          message.error("请完善表单")
        })
    }
    return {
      oss,
      ...toRefs(state),
      beforeUpload,
      handlePreview,
      ImagesChange,
      onSubmit,
      form,
      ruleForm,
    }
  },
}
</script>
